var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClaimActivity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2439_16260",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2439_16260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33335 8.49967V7.16634H10.6667V8.49967H5.33335ZM5.33335 5.83301V4.49967H10.6667V5.83301H5.33335ZM4.00002 9.83301H9.00002C9.32224 9.83301 9.62224 9.90245 9.90002 10.0413C10.1778 10.1802 10.4111 10.3775 10.6 10.633L12 12.4663V3.16634H4.00002V9.83301ZM4.00002 13.833H11.3667L9.55002 11.4497C9.48335 11.3608 9.4028 11.2913 9.30835 11.2413C9.21391 11.1913 9.11113 11.1663 9.00002 11.1663H4.00002V13.833ZM12 15.1663H4.00002C3.63335 15.1663 3.31946 15.0358 3.05835 14.7747C2.79724 14.5136 2.66669 14.1997 2.66669 13.833V3.16634C2.66669 2.79967 2.79724 2.48579 3.05835 2.22467C3.31946 1.96356 3.63335 1.83301 4.00002 1.83301H12C12.3667 1.83301 12.6806 1.96356 12.9417 2.22467C13.2028 2.48579 13.3334 2.79967 13.3334 3.16634V13.833C13.3334 14.1997 13.2028 14.5136 12.9417 14.7747C12.6806 15.0358 12.3667 15.1663 12 15.1663Z",
    fill: "#9CA3AF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimActivity);
export default __webpack_public_path__ + "static/media/claim_activity.1659adccc3550e921a771952c45131a2.svg";
export { ForwardRef as ReactComponent };